/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Grower_AreasInputs */

const vi_grower_areas = /** @type {(inputs: Grower_AreasInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vùng trồng`)
};

/**

* @param {Grower_AreasInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const grower_areas = /** @type {((inputs?: Grower_AreasInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Grower_AreasInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_grower_areas(inputs)
});